export type SegmentationType = 'coronal' | 'axial' | 'sagittal';
